<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>媒体发布</BreadcrumbItem>
        <BreadcrumbItem>在线学习</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='4'>
      <Input v-model="searchParam.name" placeholder="标题" />
      </Col>

      <Col span='1'>
      <Button type="info" @click='searchData'>查询</Button>
      </Col>
      <ul class='conheadRight'>
        <i-button type="error" @click='sModal(-1)'>新增专题</i-button>
      </ul>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :isdrag='isdragd' :issearch='issearch'
        @smodal='sModal'>
      </tablePage>
    </section>

    <Modal v-model="edit" title='新增/修改' :mask-closable='false' width='700px'>

      <Form label-position="top" :model='formItem' ref='formCustom'>
        <Row>
          <Col span="11">
          <FormItem label="专题名称">
            <Input v-model="formItem.name" type='text'></Input>
          </FormItem>
          </Col>
          <Col span="11" offset="2">
          <FormItem label="排序">
            <InputNumber v-model="formItem.sort" style='width:100%;'></InputNumber>
          </FormItem>
          </Col>
        </Row>

        <FormItem label="封面图片">
          <input type="hidden" v-model='formItem.icon'>
          <upImg @upImglist='upImglist' :extradata='selfIcon.pictype' :defaultimg='formItem.icon' :datanum='treekey'
            :defaultname='selfIcon.name'></upImg>
          <p style='color:#e22a1c'>图片尺寸：{{ selfIcon.pictype.size }}</p>
        </FormItem>
        <FormItem label="内链地址" v-if='formItem.guid'>
          <!-- <Input v-model="formItem.url" type='text' ></Input> -->
          <Input :value="`native://action?type=topic&id=${formItem.guid}`" type='text'></Input>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="formItem.remark" type='textarea'></Input>
        </FormItem>

        <FormItem label="下级栏目" v-if='formItem.guid != ""'>
          <Row v-for="(item, index) in detialList" :key="index" style='margin-bottom:20px'>
            <Col span="7">
            <Input v-model="item.name" type='text'></Input>
            </Col>
            <Col span="7" offset="1">
            <InputNumber v-model="item.sort"></InputNumber>
            </Col>
            <Col span="3" offset="1">
            <Button @click="handleEdit(index, item)">修改</Button>
            </Col>
            <Col span="3" offset="1">
            <Button @click="handleRemove(index, item)">删除</Button>
            </Col>
          </Row>
        </FormItem>
        <FormItem v-if='formItem.guid != ""'>
          <Row style='margin-bottom:30px;'>
            <Col span="7">
            <Input type='text' v-model='newAddData'></Input>
            </Col>
            <Col span="7" offset="1">
            <InputNumber v-model='newAddDataSort'></InputNumber>
            </Col>
            <Col span="5" offset="1">
            <Button type="dashed" @click="handleAdd" icon="md-add">添加</Button>
            </Col>
          </Row>
        </FormItem>
      </Form>
      <div slot="footer" style='position:relative;clear:both'>

        <Button type="error" @click='removeItem' class='remove' icon="md-trash" v-if='formItem.guid != ""'>删除</Button>
        <Button type="default" @click='edit = false' icon="md-close">取消</Button>
        <Button type="info" @click='update' icon="md-checkmark-circle-outline">保存</Button>
      </div>
    </Modal>

  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
import upImg from './upImgnew'
export default {
  name: 'newslist',

  components: {
    tablePage,
    bemodal,
    upImg
  },
  data () {
    return {
      isdragd: true,
      curItem: {},
      treekey: 0,
      detialList: [],
      formItem: {
        name: '',
        remark: '',
        sort: 1,
        guid: '',
        url: '',
        icon: '',
      },
      selfIcon: {
        pictype: {
          type: 'zl',
          size: '686*280'
        },
        name: 'icon'
      },
      newAddData: '',
      newAddDataSort: 1,
      edit: false,
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      formData: [
        ['dic/getId', 'dic/save', 'dic/delete'],
        [
          {
            type: 'input',
            title: '专题名称',
            name: 'name',
            model: '',
            block: true,
          },
          {
            type: 'input',
            title: '内链地址',
            name: 'url',
            model: '',
            block: true,
          },
          {
            type: 'numberInput',
            title: '排序',
            name: 'sort',
            model: 1,
            block: true,
          },
          {
            type: 'uploadimg',
            title: '封面',
            name: 'icon',
            pictype: {
              type: 'gallery',

            },
            model: '',
            block: true,
          },
          {
            type: 'textarea',
            title: '备注',
            name: 'remark',
            model: ''
          },


          {
            type: 'hidden',
            children: [{
              name: 'guid',
              model: ''
            }, {
              name: 'rootid',
              model: 'news',
            }, {
              name: 'pid',
              model: "5689fdde-11d2-444d-9bb2-b75e3b802e46",
            }]
          }
        ]
      ],
      queryData: ['dic/getQueryList?sort=999',
        [
          {
            title: '封面',
            key: '',
            render: (h, params) => {

              return h('viewer', [
                h('img', {
                  style: {//设置样式
                    display: 'inline-block',
                    width: '49px',
                    height: '27px',
                  },
                  attrs: {//设置属性
                    src: params.row.icon
                  }
                })]
              )

            }

          },
          {
            title: '专题名称',
            key: 'name',
            render: (h, params) => {
              return h('span', decodeURI(params.row.name))
            }
          },
          {
            title: '排序',
            key: 'sort',
            width: 150,
            align: 'center',
          },
          {
            title: '内链地址',
            key: '',
            render: (h, params) => {
              return h('span', 'native://action?type=topic&id=' + params.row.guid)
            }
          },
          {
            title: '操作',
            slot: 'action',
            width: 110,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '60px',
                    height: '25px',
                    background: '#2db7f5',
                    borderRadius: '6px',
                    textAlign: 'center',
                    lineHeight: '25px',
                    color: '#fff',
                    fontSize: '12px',
                    cursor: 'pointer',
                    userSelect: 'none'
                  },
                  on: {
                    click: () => {


                      this.curItem = params.row
                      this.showItem()



                    }
                  }
                }, '编辑')
              ])
              // <span class='do' @click="show(index,row)">编辑</span>
            }
          }

        ]
      ],
      searchParam: {
        name: '',
        rootid: 'news',
        pid: '5689fdde-11d2-444d-9bb2-b75e3b802e46',
      },
      issearch: -1,
      newAddData: '',
      newAddDataSort: 1,
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
  },
  methods: {
    update () {

      var name = this.formItem.name
      var that = this
      if (name == '') {
        this.$Message.info('专题名称不能为空')
        return false
      }
      if (this.formItem.icon == '') {
        this.$Message.info('请上传专题图片')
        return false
      }
      var param = {
        name: name,
        url: this.formItem.url,
        sort: this.formItem.sort,
        icon: this.formItem.icon,
        remark: this.formItem.remark,
        rootid: 'news',
        guid: this.formItem.guid,
        pid: '5689fdde-11d2-444d-9bb2-b75e3b802e46'
      }




      console.log(param)

      this.axios.post('dic/save', param).then(res => {
        that.$Message.info('成功')
        that.edit = false
        that.searchData()
      })
    },
    handleRemove (index, item) {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          var _items = that.detialList
          _items.splice(index, 1)
          that.detialList = _items
          that.axios.post('dic/delete', { id: item.guid }).then(res => {
            console.log(res)
            that.$Message.success(res.msg)
          }).catch(function (res) {
            that.$Message.error('未知问题')
          })
        },
        onCancel: () => {

        }
      });

    },
    removeItem () {
      var that = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          that.axios.post('dic/delete', { id: that.curItem.guid }).then(res => {
            console.log(res, 'res')
            that.$Message.info('删除成功')
            that.edit = false
            that.searchData()
          }).catch(function (res) {
            that.$Message.error('未知问题')
          })
        },
        onCancel: () => {

        }
      });

    },
    handleEdit (index, item) {

      var that = this
      //   this.$Modal.confirm({
      //     title: '提示',
      //     content: '<p>是否确认修改？</p>',
      //     onOk: () => {
      var param = {
        rootid: 'news',
        pid: item.pid,
        name: item.name,
        guid: item.guid,
        remark: '',
        url: '',
        sort: item.sort
      }
      that.axios.post('dic/save', param).then(res => {
        console.log(res)
        that.$Message.success(res.msg)
      }).catch(function (res) {
        that.$Message.error('未知问题')
      })
      // },
      // onCancel: () => {

      // }
      // });
    },
    showItem () {
      var that = this
      this.edit = true
      this.handleData()
      this.axios.get('dic/getId', { params: { id: this.curItem.guid } }).then(res => {
        console.log(res, 'res')
        if (res.msg) {
          that.formItem.name = res.data.name
          that.formItem.remark = res.data.remark
          that.formItem.sort = Number(res.data.sort)
          that.formItem.url = res.data.url
          that.formItem.guid = res.data.guid
          that.formItem.icon = res.data.icon
          that.treekey = Math.random()

        }

        // that.$Message.info('成功')
        //  that.newAddData = ''
        // that.getGrade()
        //  that.handleData()
        //  that.detialList.push({
        //      name: '',
        //      index: _index++,
        //  });
      })
    },
    upImglist (e) {
      console.log(e)
      var str = []
      var _img = e.pics
      _img.map(function (val, index) {
        var pic = val['response']['data']['file']
        console.log(pic)
        str.push(pic.split("@")[0])
      })
      console.log(str)
      this.formItem.icon = this.storepic = str.join(',')

    },
    handleData () {

      var that = this
      that.axios.get('dic/getQueryList', { params: { sort: 999, pid: this.curItem.guid } }).then(function (res, back) {
        console.log(res, back, 'res')
        that.detialList = res.data
        res.data.map(function (val, index) {
          val['sort'] = Number(val['sort'])
        })
        res.data = res.data.reverse()
        that.newAddDataSort = Number(res.data.length + 1)
      })
    },
    handleAdd () {
      var _index = this.detialList.length
      console.log(_index)
      //console.log(this.formItem.detialList[_index-1])
      var that = this
      if (this.newAddData == '') {
        this.$Message.info('名称不能为空')
        return false
      }
      this.newAddDataSort = ++_index
      var param = {
        rootid: 'news',
        pid: this.formItem.guid,
        name: this.newAddData,
        guid: '',
        remark: '',
        url: '',
        sort: this.newAddDataSort
      }

      console.log(param)

      this.axios.post('dic/save', param).then(res => {
        that.$Message.info('成功')
        that.newAddData = ''

        that.handleData()
        that.detialList.push({
          name: '',
          index: _index++,
        });
      })
    },
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid) {

      if (guid == -1) {
        this.edit = true
        this.formItem = {
          name: '',
          remark: '',
          sort: 1,
          guid: '',
          url: '',
          icon: '',
        }
        this.treekey = Math.random()
      }
    },
    reloadTable () {
      this.issearch = Math.random()
    }
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
}

.remove {
  float: left;
}
</style>
